document
	.querySelectorAll('.wp-block-metawood-job-positions-slider .swiper')
	.forEach((swiperEl) => {
		const slideLength = swiperEl.querySelectorAll('.swiper-slide').length;
		const settings = {
			loop: slideLength > 3,
			speed: 1000,
			allowTouchMove: true,
			simulateTouch: true,
			touchStartPreventDefault: false,
			touchMoveStopPropagation: false,
			autoplay: slideLength > 3 && {
				delay: 5000,
				pauseOnMouseEnter: true,
				disableOnInteraction: true,
			},

			navigation: {
				nextEl: swiperEl.querySelector('.button-next'),
				prevEl: swiperEl.querySelector('.button-prev'),
				disabledClass: 'disabled',
			},
			pagination: {
				el: swiperEl.querySelector('.pagination'),
				type: 'fraction',
				renderFraction: function (currentClass, totalClass) {
					return (
						'<span class="' +
						currentClass +
						'"></span>' +
						'/' +
						'<span class="' +
						totalClass +
						'"></span>'
					);
				},
			},
		};

		// Init Swiper
		const swiper = new Swiper(swiperEl, settings);

		// Pause autoplay until visible
		if (swiper.params.autoplay.enabled) {
			swiper.autoplay.pause();
		}

		// Intersection Observer to start autoplay the first time it's visible
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (swiper.params.autoplay.enabled)
							swiper.autoplay.start();
						observer.unobserve(swiperEl);
					}
				});
			},
			{
				threshold: 0.25,
			}
		);

		observer.observe(swiperEl);
	});
